// frontend/smartdocs-admin/src/store/chatStore.ts
import { create } from 'zustand';

export interface ChatMessage {
  id: number;
  text: string;
  direction: 'ltr' | 'rtl';
  isResponseTime: boolean;
  sender: 'user' | 'ai';
  responseTime?: string;
  timestamp: string;
  isError?: boolean;
}

interface ChatStore {
  messages: ChatMessage[];
  addMessage: (message: ChatMessage) => void;
  clearMessages: () => void;
}

// Define the chat store
const useChatStore = create<ChatStore>((set) => ({
  messages: [], // Initial state: an empty array for messages

  // Action to add a new message to the chat
  addMessage: (message) => set((state) => ({
    messages: [...state.messages, message], // Append the new message to the existing messages
  })),

  // Action to clear all messages (e.g., on browser refresh or explicit clear)
  clearMessages: () => set({ messages: [] }),
}));

export default useChatStore;
